import { Progress } from "@/components/ui/progress";

interface LevelProgressProps {
  badgeCount: number | null;
  getNextLevelRequirement: () => number;
  getLevelProgress: () => number;
  userLevel?: string;
}

export const LevelProgress = ({ 
  badgeCount, 
  getNextLevelRequirement, 
  getLevelProgress,
  userLevel 
}: LevelProgressProps) => {
  return (
    <div className="mt-6 p-4 bg-primary/10 dark:bg-gray-800/50 rounded-lg backdrop-blur-sm">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold">Nivel Actual</h2>
          <p className="text-2xl font-bold text-foreground">
            {userLevel 
              ? userLevel.charAt(0).toUpperCase() + userLevel.slice(1) 
              : "Cargando..."}
          </p>
        </div>
        <div className="text-right">
          <p className="text-sm text-foreground">Logros Obtenidos</p>
          <p className="text-2xl font-bold">{badgeCount} / {getNextLevelRequirement()}</p>
        </div>
      </div>
      <Progress value={getLevelProgress()} className="h-2" />
      <p className="text-sm text-foreground mt-2">
        {badgeCount >= 50 
          ? "¡Has alcanzado el nivel máximo!" 
          : `${getNextLevelRequirement() - (badgeCount || 0)} logros más para el siguiente nivel`}
      </p>
    </div>
  );
};